import React from 'react';
import { CASE_REVIEW_STATUS_REJECTED } from './CaseConstants';
import CaseList from './CaseList';
import { APP_TERMS } from '../../app-terms';
const BREAD_CRUMBS = [
  { label: 'Case', to: '/user/case/rejected' },
  { label: 'Completed', to: '/user/case/rejected' },
];
const RejectedCases = () => {
  return (
    <div>
      <div>
        <CaseList
          title={APP_TERMS.rejected_case_list_title}
          caseReviewStatus={CASE_REVIEW_STATUS_REJECTED}
          breadCrumbItems={BREAD_CRUMBS}
        />
      </div>
    </div>
  );
};

export default RejectedCases;
